export default __webpack_public_path__ + "static/media/qr-image.5f813eda.png";